import { createShigoApiClient, type ShigoApiConfig } from '../../lib/shigo-api-client';
import { dashboardPublishersPageSchema } from './model';

type DashboardPublishersClientOptions = {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
};

export function createDashboardPublishersClient({
  config,
  accessToken,
  fetcher,
}: DashboardPublishersClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);

  return {
    listAssigned(publisherIds: readonly string[]) {
      const search = new URLSearchParams({ ids: publisherIds.join(',') });
      return api.request({
        path: `/api/publishers?${search.toString()}`,
        schema: dashboardPublishersPageSchema,
      });
    },
  };
}
